/* eslint-disable @typescript-eslint/no-explicit-any */
import { takeLatest } from 'redux-saga/effects';

import * as commonSagas from '../_common/commonSagas';
import * as destPointDetailsSlice from './destPointDetailsSlice';

export default function* watchDestPointDetailsSaga() {
 yield takeLatest(destPointDetailsSlice.getTableStart.type, commonSagas.getTable);
 yield takeLatest(destPointDetailsSlice.getItemStart.type, commonSagas.getItem);
 yield takeLatest(
  destPointDetailsSlice.createItemStart.type,
  commonSagas.createItem,
 );
 yield takeLatest(
  destPointDetailsSlice.updateItemStart.type,
  commonSagas.updateItem,
 );
 yield takeLatest(
  destPointDetailsSlice.deleteItemsStart.type,
  commonSagas.deleteItems,
 );
 yield takeLatest(
  destPointDetailsSlice.deleteItemStart.type,
  commonSagas.deleteItem,
 );
 yield takeLatest(
  destPointDetailsSlice.getTableStructureStart.type,
  commonSagas.getTableStructure,
 );
 yield takeLatest(
  destPointDetailsSlice.getItemDocumentsStart.type,
  commonSagas.getItemDocuments,
 );
 yield takeLatest(
  destPointDetailsSlice.uploadItemDocumentsStart.type,
  commonSagas.uploadItemDocuments,
 );
 yield takeLatest(
  destPointDetailsSlice.deleteItemDocumentStart.type,
  commonSagas.deleteItemDocument,
 );
 yield takeLatest(
  destPointDetailsSlice.getTableExcelStart.type,
  commonSagas.getTableExcel,
 );
}
